// extracted by css-extract-rspack-plugin
export default {"forgotPasswordPage":"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__forgotPasswordPage-huLS8S","content":"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__content-uLJGLQ","header":"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__header-i1UlFy","title":"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__title-tcjpzV","description":"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__description-Lw3qJ9"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"forgotPasswordPage\":\"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__forgotPasswordPage-huLS8S\",\"content\":\"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__content-uLJGLQ\",\"header\":\"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__header-i1UlFy\",\"title\":\"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__title-tcjpzV\",\"description\":\"src-modules-auth-pages-ForgotPasswordPage-ForgotPasswordPage-module__description-Lw3qJ9\"}";
        // 1793873546846
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  